import { capitalize } from 'lodash';
import TaffiLogoWhite from '../../../assets/svg/Taffi_Logo_white.svg';
import TaffiIconWhite from '../../../assets/svg/Taffi_Icon_White.svg';
import { useStyles } from './styles';
import { useMutation } from '@apollo/client';
import { UPDATE_PROFILE } from 'graph_ql/authentication/mutation';
import { useCallback, useEffect } from 'react';
import { trackEvent, TRACK_EVENT } from 'utils/analytics';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export interface ICompleteQuizPageProps {
    completeQuizProcess: () => void;
}

export default function CompleteQuizPage({ completeQuizProcess }: ICompleteQuizPageProps) {
    const classes = useStyles();
    const userDetail = useSelector((state: RootState) => state.userDetail.me);
    const welcomeTitle = userDetail?.quizCompleted
        ? `Thank you ${capitalize(userDetail?.firstName)}!`
        : `Congratulations ${capitalize(userDetail?.firstName)}!`;
    const listTitle = userDetail?.quizCompleted
        ? `Your personal style profile is now updated. This allows us to provide improved personalization services
    when you:`
        : `You have now unlocked a truly personalized fashion world for yourself where you can:`;

    const [updateProfileMutation] = useMutation(UPDATE_PROFILE, {
        onCompleted() {
            if (userDetail?.quizCompleted) {
                trackEvent(TRACK_EVENT.USER_QUIZ_UPDATE, {
                    userId: userDetail?.id,
                    userType: userDetail?.userType,
                    email: userDetail?.email,
                });
            } else {
                trackEvent(TRACK_EVENT.USER_QUIZ_COMPLETE, {
                    userId: userDetail?.id,
                    userType: userDetail?.userType,
                    email: userDetail?.email,
                });
            }
        },
        onError(error) {
            console.log('error', error);
        },
    });

    const updateProfile = useCallback(
        (input: { quizCompleted: boolean }) => {
            const variables = {
                input,
            };
            return updateProfileMutation({ variables });
        },
        [updateProfileMutation],
    );

    useEffect(() => {
        updateProfile({
            quizCompleted: true,
        });
    }, [updateProfile]);
    return (
        <div className={`${classes.container} ${classes.containerBg}`}>
            <div className={classes.imgContainer}>
                <img src={TaffiLogoWhite} alt="Taffi" height={21} width={65} />
            </div>
            <div className={classes.contentContainer}>
                <div className={classes.welcomeContainer}>
                    <img src={TaffiIconWhite} alt="Taffi" height={56} width={56} />
                    <div className={`${classes.welcomeTitle} ${classes.textColorComplete}`}>{welcomeTitle}</div>
                </div>
                <div className={`${classes.listContainer} ${classes.textColorComplete}`}>
                    <div style={{}}>{listTitle}</div>
                    <div className={classes.list}>
                        <ul className={classes.pl20}>
                            <li>Connect to a personal stylist.</li>
                            <li>Shop looks completely personalized to you.</li>
                            <li>Refer to your style profile anytime you need a fashion refresh.</li>
                        </ul>
                    </div>
                </div>
            </div>

            <button className={`${classes.button} ${classes.completeButtonColors}`} onClick={completeQuizProcess}>
                {'Let’s go styling'.toUpperCase()}
            </button>
        </div>
    );
}
